var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonCloseFilled2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.15 1.5 1.5 6.15 1.5 12C1.5 17.85 6.15 22.5 12 22.5C17.85 22.5 22.5 17.85 22.5 12C22.5 6.15 17.85 1.5 12 1.5ZM16.65 16.65C16.3186 16.9814 15.7814 16.9814 15.45 16.65L12 13.2L8.55 16.65C8.21863 16.9814 7.68137 16.9814 7.35 16.65C7.01863 16.3186 7.01863 15.7814 7.35 15.45L10.8 12L7.35 8.55C7.01863 8.21863 7.01863 7.68137 7.35 7.35C7.68137 7.01863 8.21863 7.01863 8.55 7.35L12 10.8L15.45 7.35C15.7814 7.01863 16.3186 7.01863 16.65 7.35C16.9814 7.68137 16.9814 8.21863 16.65 8.55L13.2 12L16.65 15.45C16.9814 15.7814 16.9814 16.3186 16.65 16.65Z",
    fill: "#D0D0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCloseFilled2);
export default __webpack_public_path__ + "static/media/carbon_close-filled2.9d3af8eca6bfee6f33899f8a635bac47.svg";
export { ForwardRef as ReactComponent };